<template>
  <div>
    <p class="tw-text-muted tw-mb-4 tw-text-sm">
      Schedules, manual job runs, MLS vs destination counts, and recent history for this feed.
    </p>

    <div class="source-grid">
      <Card class="source-span-2">
        <template #title>Schedule</template>
        <template #subtitle>Next runs and cron strings · muted when disabled</template>
        <template #content>
          <query-loader
            :query="gql => gql`
              query CronSchedules($sourceName: String) {
                cronSchedules(sourceName: $sourceName) {
                  sourceName
                  sync { cronStrings nextDate enabled }
                  purge { cronStrings nextDate enabled }
                  reconcile { cronStrings nextDate enabled }
                }
              }
            `"
            :variables="{ sourceName }"
          >
            <template v-slot="{ data }">
              <CronSchedules :schedules="data.cronSchedules" />
            </template>
          </query-loader>
        </template>
      </Card>

      <Card>
        <template #title>Run now</template>
        <template #subtitle>Blocked while another job for this source is active</template>
        <template #content>
          <JobRunner :source-name="sourceName" />
        </template>
      </Card>
    </div>

    <Card class="tw-mb-4">
      <template #title>Resources</template>
      <template #subtitle>MLS counts vs destinations · refresh to recheck</template>
      <template #content>
        <StatsDetailsContainer :source-name="sourceName" />
      </template>
    </Card>

    <Card>
      <template #title>History</template>
      <template #subtitle>Recent sync, purge, and reconcile batches</template>
      <template #content>
        <SyncStatsContainer :key="sourceName" :source-name="sourceName" v-slot="{ stats }">
          <Message
            v-if="stats && stats.demoMode"
            severity="warn"
            :closable="false"
            class="tw-mb-3"
          >
            Job history unavailable — stats DB is down. Nothing here is invented; history will appear when the connection recovers.
          </Message>
          <TabView>
            <TabPanel header="Sync">
              <SyncStats :stats="stats.sync" />
            </TabPanel>
            <TabPanel header="Purge">
              <PurgeStats :stats="stats.purge" />
            </TabPanel>
            <TabPanel header="Reconcile">
              <ReconcileStats :stats="stats.reconcile" />
            </TabPanel>
          </TabView>
        </SyncStatsContainer>
      </template>
    </Card>
  </div>
</template>

<script>
import SyncStatsContainer from './SyncStatsContainer'
import SyncStats from './SyncStats'
import PurgeStats from './PurgeStats'
import ReconcileStats from './ReconcileStats'
import StatsDetailsContainer from './StatsDetailsContainer'
import CronSchedules from './CronSchedules'
import JobRunner from './JobRunner'

export default {
  props: {
    sourceName: String,
  },
  components: {
    CronSchedules,
    SyncStatsContainer,
    SyncStats,
    PurgeStats,
    ReconcileStats,
    StatsDetailsContainer,
    JobRunner,
  },
}
</script>

<style scoped>
.source-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.source-span-2 {
  min-width: 0;
}

@media (max-width: 960px) {
  .source-grid {
    grid-template-columns: 1fr;
  }
}
</style>
